import { render, staticRenderFns } from "./JobCategory.vue?vue&type=template&id=77545751&"
import script from "./JobCategory.vue?vue&type=script&lang=js&"
export * from "./JobCategory.vue?vue&type=script&lang=js&"
import style0 from "./JobCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports